module.exports = __webpack_public_path__ + "img/cut_gd2.f3487114.jpg";